module.exports = __webpack_public_path__ + "media/images/devise/icon_1-1efbe712595c255f06d8747261b307ce.svg";